import { createFileRoute } from '@tanstack/react-router'
import { SensorScan } from '@/components/installFlowV2/sensor-scan'
import { z } from 'zod'

export const Route = createFileRoute('/installFlow/sensor-scan')({
  component: SensorScan,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
})
